<template>
    <b-container fluid>
        <app-modal
            title="Aviso de pago pendiente"
            id="pending_payment-window"
            size="xl"
            centered
            :header-bg-variant="!venueBlocked ? 'warning' : 'danger'"
            :body-bg-variant="!venueBlocked ? 'warning' : 'danger'"
            :footer-bg-variant="!venueBlocked ? 'warning' : 'danger'"
            header-text-variant="white"
            body-text-variant="white"
            no-close-on-backdrop
            no-close-on-escs
            hide-header-close
            hide-footer
        >
            <b-row align-v="center">
                <template v-if="!venueBlocked">
                    <b-col cols="12" md="12">
                        <span style="font-size: 2rem; font-weight: bold">
                            {{
                                'Por favor recuerde realizar el pago de su licencia por valor de $' +
                                this.licensePrice +
                                '. El sistema ha identificado que a la fecha tiene una mora de ' +
                                this.daysLate +
                                ' días. Puede realizar el pago a través de PSE en el siguiente '
                            }}
                        </span>
                        <a
                            href="https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago?idConv=00018589&origen=buscar"
                            target="_blank"
                            style="font-size: 2rem; font-weight: bold"
                            >link</a
                        >
                        <span style="font-size: 2rem; font-weight: bold">
                            {{ 'y enviar el comprobante a pagos@intuscolombia.com. Si ya realizó el pago por favor omita este mensaje.' }}
                        </span>
                    </b-col>
                    <b-button @click="loadGuard" variant="primary" class="button-desaign">Aceptar y continuar</b-button>
                </template>
                <template v-else>
                    <b-col cols="12" md="12">
                        <span style="font-size: 2rem; font-weight: bold">
                            {{
                                'Actualmente su licencia se encuentra suspendida. Por favor recuerde realizar el pago por valor de $' +
                                this.licensePrice +
                                '. El sistema ha identificado que a la fecha tiene una mora de ' +
                                this.daysLate +
                                ' días. Puede realizar el pago a través de PSE en el siguiente '
                            }}
                        </span>
                        <a
                            href="https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago?idConv=00018589&origen=buscar"
                            target="_blank"
                            style="font-size: 2rem; font-weight: bold"
                            >link</a
                        >
                        <span style="font-size: 2rem; font-weight: bold">
                            {{ 'y enviar el comprobante a pagos@intuscolombia.com. Si ya realizó el pago por favor omita este mensaje.' }}
                        </span>
                    </b-col>
                </template>
            </b-row>
        </app-modal>
        <div class="d-flex justify-content-center mb-5">
            <!-- <b-img src="img/banner_vecindapp.png"></b-img> -->
            <b-img :src="isReseller && !!currentClient && currentClient.banner_url ? currentClient.banner_url : 'img/banner_vecindapp_new_sm.png'"></b-img>
        </div>
        <b-row>
            <b-col>
                <app-sub-title>Selección de Sede a Vigilar</app-sub-title>
            </b-col>
        </b-row>
        <div v-if="!!venues.length">
            <b-row v-for="venue in venues" :key="venue.id">
                <b-col class="my-3">
                    <b-btn variant="primary" block @click="selectVenue(venue)">{{ venue.name }} ({{ venue.unit.name }})</b-btn>
                </b-col>
            </b-row>
        </div>
        <b-row v-if="validateSizeVenues">
            <b-col>
                <b-alert show variant="warning">No tiene ninguna sede asociada.</b-alert>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapMutations, mapActions } from 'vuex'
import * as mutations from '@store/_mutations'
export default {
    data: () => ({
        venues: [],
        validateSizeVenues: false,
        venueBlocked: false,
        daysLate: '',
        licensePrice: 0,
    }),
    computed: {
        //
    },
    methods: {
        ...mapMutations({
            setCapabilities: mutations.SET_CAPABILITIES,
            setGuardNotifications: mutations.SET_GUARD_NOTIFICATIONS,
        }),
        async loadVenues() {
            const { data } = await this.$repo.get('guard-venues', {
                with: 'unit:id,name,client_id;unit.client:id,name,banner_url;modules',
                append: ['guardNotifications'],
            })

            if (data.length === 1) {
                return this.selectVenue(data[0])
            }
            this.venues = data
            if (this.venues.length === 0) {
                this.validateSizeVenues = true
            }
        },
        async loadGuard(venueId) {
            const { data } = await this.$repo.get(`guards/venue/${venueId}`)
            this.setCurrentGuard(data)
            this.next()
        },
        next() {
            this.$router.push({ name: 'selectWorkplacePage' })
        },
        selectVenue(venue) {
            // this.loadRoleAndProfileCapabilities(venue.id)
            const unit = venue.unit
            const client = unit.client
            this.setCurrentVenue(venue)
            this.validatePendingPayments()
            this.setCurrentUnit(unit)
            this.setCurrentClient(client)

            this.setGuardNotifications(venue.guardNotifications)
        },

        validatePendingPayments() {
            const venue = this.currentVenue
            this.licensePrice = venue.license_price
            let lastPaymentDate = moment(venue.last_payment_date)
            let currentDate = moment()
            let dueDate = lastPaymentDate.clone().add(6, 'days').startOf('day')
            this.daysLate = Math.max(currentDate.diff(dueDate, 'days'), 0)
            if (venue.pending_payment_date && !venue.blocked) {
                this.venueBlocked = false
                this.loaded = true
                this.$nextTick(() => this.openModal('pending_payment-window'))
            } else if (venue.blocked) {
                this.venueBlocked = true
                this.loaded = true
                this.$nextTick(() => this.openModal('pending_payment-window'))
            } else {
                this.loadGuard(venue.id)
            }
        },
        async loadProfileCapabilties() {
            const { data } = await this.$repo.get(`profiles/${this.currentProfile.id}/capabilities`)

            const capabilities = Array.from(new Set([...this.capabilities, ...data]))
            this.setCapabilities(capabilities)
        },
        // async loadRoleAndProfileCapabilities(venueId) {
        //     const { data } = await this.$repo.get(
        //         'people/role-and-profile-capabilities',
        //         {
        //             profileId: this.currentUser.profiles[0].id,
        //             userId: this.currentUser.id,
        //             venueId: venueId
        //         }
        //     )
        //     this.setCapabilities(data)
        // },
    },
    created() {
        this.loadVenues()
        this.loadProfileCapabilties()
    },
}
</script>
